import { teamsGeneralInfo } from '@views/pages/BusinessAccountPage/Dashboard/MobileVersion/TeamTabs'

export const teamsInfo: teamsGeneralInfo[] = [
  { teamName: 'U-10 team', teamOwner: 'John Smith', teamBalance: 5000 },
  { teamName: 'U-12 team', teamOwner: 'David Jones', teamBalance: 3000 },
  { teamName: 'U-14 team', teamOwner: 'Steve Smith', teamBalance: 2000 },
  { teamName: 'U-16 team', teamOwner: 'John Doe', teamBalance: 1000 },
]
